@if(isBrowser){
<main>
  <!-- header START -->
  <div class="container-fluid">
    <app-header (shareUserDetail)="setUserDetails($event)"></app-header>
  </div>
  <!-- header END -->
  @if (userDetail) {
  <div>
    <!-- ALL SECTION -->
    <section class="body-left-insidepages">
      <div class="body-pad">
        <h1 class="wow animate__fadeInUp" data-wow-delay="100ms" style="margin-bottom: 80px;">Clay.com Integration with
          KudosHub</h1>
        <!-- INTEGRATE IMAGES START -->
        <div class="first-section">
          <!-- <div class="brand-div"> -->
          <div class="integrate-div wow animate__fadeInUp">
            <!-- make it routerLink to activate section -->
            <img src="theme/images/kudosHub-logo.svg" data-wow-delay="200ms" alt="Kudoshub">
          </div>
          <!-- <h2 id="KudosHub-a" class="wow animate__fadeInUp" data-wow-delay="200ms">KudosHub</h2>
          </div> -->
          <!-- <div class="brand-div"> -->
          <div class="plus-icon wow animate__fadeInUp">
            <img src="theme/images/transfer.webp" data-wow-delay="500ms" alt="integation">
          </div>
          <!-- <h2 id="with-a" class="wow animate__fadeInUp" data-wow-delay="200ms">with</h2>
          </div> -->
          <!-- <div class="brand-div"> -->
          <div class="integrate-div wow animate__fadeInUp">
            <!-- make it routerLink to activate section -->
            <img src="theme/images/integration/clay.svg" data-wow-delay="500ms" alt="Clay">
          </div>
          <!-- <h2 id="other-a" class="wow animate__fadeInUp" data-wow-delay="200ms">Clay</h2>
          </div> -->
          <!-- BACKGROUND IMAGE START -->
          <div class="bgUp"></div>
          <div class="bgUp2"></div>
          <!-- BACKGROUND IMAGE END -->
        </div>
        <!-- INTEGRATE IMAGES END -->
        <!-- INTEGRATE SEACTION START -->
        <!-- <div id="section-2">
          <div class="integrate  wow animate__fadeInUp" data-wow-delay="500ms">


          </div>
        </div> -->
        <!-- INTEGRATE SECTION END -->
        <!-- INTEGRATION PARAGRAPH START -->

        <div id="section-3">
          <p class="wow animate__fadeInUp" data-wow-delay="300ms">Powered by AI Email Scoring. Secure, fast, and ready
            to scale.</p>
          <button class="get-started-btn2 wow animate__fadeInUp" data-wow-delay="400ms" routerLink="/register">Get 3,000
            Free
            Credits</button>
          <p class="wow animate__fadeInUp" data-wow-delay="500ms"
            style="font-weight:500;padding:0;text-align: center !important; animation-delay: 1500ms; margin-top: 5px !important; margin-bottom: 10px; font-size: 16px !important;">
            Simple setup. Seamless connection.</p>
        </div>
        <div class="middle-content">
          <h2 class="bdy-left-mainhead wow animate__fadeInUp" style="text-transform: none;">
            What’s Included in the KudosHub Clay.com Integration
          </h2>
          <figure class="wave wow animate__fadeInUp">
            <img src="theme/images/wave.gif" alt="KudosHub Technologies" width="43" height="9" loading="lazy" />
          </figure>
          <div class="disclaimer-points wow animate__fadeInUp">
            <p class="wow animate__fadeInUp">
              Get advanced real-time email validation inside Clay.com. Validate, score, and sync contacts with 99%
              accuracy through a secure API connection.
            </p>
            <!-- <p class="wow animate__fadeInUp"></p> -->
            <ul>
              <li class="wow animate__fadeInUp">
                <h3>Real-Time Email Validation</h3> - KudosHub runs 16+ intelligent checks to identify invalid,
                disposable, risky, and catch-all emails directly inside Clay.com.
              </li>
              <li class="wow animate__fadeInUp">
                <h3>AI-Powered Email Scoring</h3> - Each email receives a quality score that helps teams filter
                low-value contacts and prioritize stronger leads.
              </li>
              <li class="wow animate__fadeInUp">
                <h3>99% Verified Accuracy</h3> - Achieve trusted results with proven 99% accuracy that reduces bounces
                and prevent spam traps to protect sender reputation.
              </li>
              <li class="wow animate__fadeInUp">
                <h3>Automated Data Sync</h3> - Validation results and AI scores sync automatically inside Clay.com to
                keep all contact records updated and accurate.
              </li>
              <li class="wow animate__fadeInUp">
                <h3>Secure API Connection</h3> - All API requests use encrypted HTTPS connections to ensure safe data
                transfer between your Clay workspace and KudosHub.
              </li>
              <li class="wow animate__fadeInUp">
                <h3>Dedicated Integration Support</h3> - Get responsive help from the KudosHub team for setup,
                troubleshooting & optimization to ensure a smooth Clay.com integration.
              </li>
            </ul>
          </div>
          <h2 class="bdy-left-mainhead wow animate__fadeInUp" style="text-transform: none;">
            Why Validating Emails Inside Clay.com Matters
          </h2>

          <figure class="wave wow animate__fadeInUp">
            <img src="theme/images/wave.gif" alt="KudosHub Technologies" width="43" height="9" loading="lazy" />
          </figure>

          <div class="disclaimer-points wow animate__fadeInUp">
            <p class="wow animate__fadeInUp">
              Data quality decides campaign success. Validating emails inside Clay.com keeps your workflows clean, your
              deliverability strong, and your sender reputation protected.
            </p>

            <ul>
              <li class="wow animate__fadeInUp">
                <h3>Built for Real-Time Precision</h3> - KudosHub doesn’t just verify syntax. It runs 16+ AI-powered
                checks — detecting spam traps, catch-alls, role accounts, and temporary emails before they reach Clay.
              </li>

              <li class="wow animate__fadeInUp">
                <h3>Protect Deliverability and Domain Health</h3> - Invalid or risky contacts create bounce spikes that
                damage sender reputation. KudosHub filters them instantly to maintain consistent inbox placement.
              </li>

              <li class="wow animate__fadeInUp">
                <h3>Stop Wasting Resources on Bad Leads</h3> - Invalid contacts waste email credits, CRM space, and team
                time. KudosHub ensures only verified, high-quality leads reach Clay automations.
              </li>

              <li class="wow animate__fadeInUp">
                <h3>Enhance Targeting with AI Email Scoring</h3> - Not all valid emails perform equally. KudosHub ranks
                each address by engagement potential to help you prioritize responsive leads.
              </li>

              <li class="wow animate__fadeInUp">
                <h3>Achieve Long-Term List Hygiene</h3> - Automated validation keeps Clay records accurate over time.
                KudosHub updates results in real time to prevent list decay.
              </li>
            </ul>
          </div>
          <h2 class="bdy-left-mainhead wow animate__fadeInUp" style="text-transform: none;">
            How to Set Up the KudosHub Clay.com Integration
          </h2>
          <figure class="wave wow animate__fadeInUp">
            <img src="theme/images/wave.gif" alt="KudosHub Technologies" width="43" height="9" loading="lazy" />
          </figure>
          <section class="step-section position-relative">
            <div id="steps" class="position-absolute" style="top: -8%;"></div>
            <p style="text-align: center;" class="wow animate__fadeInUp">Follow these steps to connect KudosHub with
              Clay.com using our validation API.
              Configure your action, map
              fields, and automate real-time email verification.</p>
            <div class="step-element">
              <h3 class="step-head wow animate__fadeInUp">Create Your KudosHub API Key</h3>
              <p class="wow animate__fadeInUp">Generate your API key inside the KudosHub dashboard. Use it in all
                authenticated requests to the
                validation endpoint for secure access.</p>
            </div>
            <div class="step-element">
              <h3 class="step-head wow animate__fadeInUp">Configure the Clay.com HTTP Action</h3>
              <p class="wow animate__fadeInUp">Create an HTTP request action in Clay.com. Set the method to POST and
                point the URL to the KudosHub
                validation endpoint.
              </p>
            </div>
            <div class="step-container wow animate__fadeInUp">
              <strong>
                <Section></Section>Step 1
              </strong>
              <div>
                <h4>Open the Actions menu : </h4>
                <p>Go to the Actions panel inside your Clay table and choose the Enrichment
                  tab.
                </p>
              </div>
            </div>
            <div class="step-container wow animate__fadeInUp">
              <strong>Step 2</strong>
              <div>
                <h4>Select the HTTP API action : </h4>
                <p>Search for the HTTP API option and open the configure tab.
                </p>
              </div>
            </div>
            <div class="img-container wow animate__fadeInUp">
              <img src="theme/images/integration/clay/clay_configure_screen.webp"
                alt="Clay.com HTTP API configure screen">
            </div>
            <div class="step-container wow animate__fadeInUp">
              <strong>Step 3</strong>
              <div>
                <h4>Add the KudosHub validation endpoint : </h4>
                <p>Enter the following URL and set the method to POST:</p>
                <br>
                <a class="copyLink" href="#" (click)="copyToClipboard($event)">https://api.kudoshub.com/v1/validate<span
                    class="tooltiptext">{{copyButtonText}}</span></a>
              </div>
            </div>
            <div class="step-container wow animate__fadeInUp">
              <strong>Step 4</strong>
              <div>
                <h4>Add your required query parameters : </h4>
                <p>In the Query Parameters section, fill in:</p>
                <p><strong>email : </strong>select the email column to validate</p>
                <p><strong>api-key : </strong>paste your KudosHub API key</p>
                <a class="copyLink" href="#" (click)="copyToClipboard($event)">https://api.kudoshub.com/v1/validate<span
                    class="tooltiptext">{{copyButtonText}}</span></a>
              </div>
            </div>
            <div class="img-container wow animate__fadeInUp">
              <img src="theme/images/integration/clay/clay_query_parameters.webp"
                alt="Clay.com query parameters for KudosHub Email Validation API request">
            </div>
            <div class="step-container wow animate__fadeInUp">
              <strong>Step 5</strong>
              <div>
                <h4>Enable AI scoring for deeper lead insights (optional) : </h4>
                <p>Add the scoring parameter to receive an
                  AI-generated quality score for each email. This helps you identify stronger leads, improve
                  targeting,
                  and prioritize contacts that are more likely to convert. To include AI email scoring, add:-
                </p>
                <p><strong>score : </strong>true</p>
                <a class="copyLink" href="#" (click)="copyToClipboard($event)">https://api.kudoshub.com/v1/validate<span
                    class="tooltiptext">{{copyButtonText}}</span></a>
              </div>
            </div>
            <div class="img-container wow animate__fadeInUp">
              <img src="theme/images/integration/clay/clay_query_parameters_with_scoring.webp"
                alt="Clay.com query parameters for KudosHub Email Validation and AI Email Scoring API request">
            </div>
            <div class="step-container wow animate__fadeInUp">
              <strong>Step 6</strong>
              <div>
                <h4>Credit usage details : </h4>
                <p>Validation uses 1 KudosHub credit.
                  Validation plus scoring uses 2 credits, one for each operation.
                </p>
              </div>
            </div>
            <div class="step-container wow animate__fadeInUp">
              <strong>Step 7</strong>
              <div>
                <h4>Save your configuration : </h4>
                <p>Click Save to store your settings.
                </p>
              </div>
            </div>
            <div class="step-container wow animate__fadeInUp">
              <strong>Step 8</strong>
              <div>
                <h4>Run the validation request : </h4>
                <p>Press Run to send your first request and receive validation results.
                </p>
              </div>
            </div>
            <div class="step-container wow animate__fadeInUp">
              <strong>Step 9</strong>
              <div>
                <h4>Expand and map the returned data : </h4>
                <p>Click the returned value to see status, score, and details.
                  Replace existing columns or create new ones to store the results. </p>
              </div>
            </div>
            <button class="get-started-btn2 wow animate__fadeInUp" routerLink="/docs/email-validation-api"
              style="display: block; margin: 50px auto 0px;">
              View API Documentation</button>
          </section>
          <!-- TABLE START -->

          <h2 class="bdy-left-mainhead wow animate__fadeInUp">FAQ's</h2>
          <figure class="wave wow animate__fadeInUp">
            <img src="theme/images/wave.gif" alt="KudosHub Technologies" width="43" height="9" />
          </figure>
          <div id="faq" class="faq-body">
            <div class="faq-header">
              <div class="faq-list">
                <div class="wow animate__fadeInUp" data-wow-delay="100ms">
                  <details>
                    <summary>How do I integrate KudosHub with Clay for email validation?</summary>
                    <div class="faq-content">
                      <p>You can integrate KudosHub with Clay by creating an HTTP API action, adding the KudosHub
                        validation endpoint, mapping your email column, and authenticating with your API key. Clay will
                        send each email to KudosHub and return a validation result directly into your table.</p>
                    </div>
                  </details>
                </div>

                <div class="wow animate__fadeInUp" data-wow-delay="200ms">
                  <details>
                    <summary>How can I use KudosHub’s real-time email verification inside Clay sequences?</summary>
                    <div class="faq-content">
                      <p>Add the KudosHub validation step inside your Clay sequence workflow. Each new or updated
                        contact will be verified instantly, allowing you to filter invalid emails, protect
                        deliverability, and keep your outreach sequences clean before sending any automated messages.
                      </p>
                    </div>
                  </details>
                </div>

                <div class="wow animate__fadeInUp" data-wow-delay="300ms">
                  <details>
                    <summary>How does KudosHub’s AI email scoring work within Clay automation?</summary>
                    <div class="faq-content">
                      <p>KudosHub uses an AI model to score each email by quality and engagement potential. When you
                        enable scoring in the Clay API request, Clay receives a score value that helps you prioritize
                        strong leads, segment contacts, and remove low-quality addresses from your automated workflows.
                      </p>
                    </div>
                  </details>
                </div>

                <div class="wow animate__fadeInUp" data-wow-delay="400ms">
                  <details>
                    <summary>How do I set up my KudosHub API credentials in Clay for integration?</summary>
                    <div class="faq-content">
                      <p>Generate your API key inside the KudosHub dashboard. Add it to the Clay HTTP API request under
                        query parameters as “api-key.” This key authorizes Clay to send validation or scoring requests
                        to KudosHub securely through the validation endpoint.</p>
                    </div>
                  </details>
                </div>

                <div class="wow animate__fadeInUp" data-wow-delay="500ms">
                  <details>
                    <summary>How to troubleshoot a failed data sync between Clay and KudosHub?</summary>
                    <div class="faq-content">
                      <p>First check if your API key is correct and active. Then confirm your email field is mapped
                        properly and the request method is set to POST. If Clay returns an error, verify your endpoint
                        URL and try a test request. Re-run the action after fixing the configuration.</p>
                    </div>
                  </details>
                </div>

                <div class="wow animate__fadeInUp" data-wow-delay="600ms">
                  <details>
                    <summary>What are the deliverability benefits of integrating KudosHub with Clay?</summary>
                    <div class="faq-content">
                      <p>KudosHub removes invalid, risky, and disposable emails before they enter your Clay sequences.
                        This reduces bounce rates, protects sender reputation, and improves inbox placement. Clean
                        contacts allow your outreach campaigns to perform better and deliver stronger engagement.</p>
                    </div>
                  </details>
                </div>

                <div class="wow animate__fadeInUp" data-wow-delay="700ms">
                  <details>
                    <summary>What is the difference between using KudosHub vs. Clay’s built-in email validation?
                    </summary>
                    <div class="faq-content">
                      <p>Clay provides basic checks, while KudosHub offers advanced validation with sixteen plus
                        verification layers, AI email scoring, spam trap detection, and detailed status codes. This
                        gives Clay users deeper accuracy, stronger deliverability protection, and better lead filtering.
                      </p>
                    </div>
                  </details>
                </div>

                <div class="wow animate__fadeInUp" data-wow-delay="800ms">
                  <details>
                    <summary>How can I remove disposable, spam trap, and catch-all emails in Clay using KudosHub?
                    </summary>
                    <div class="faq-content">
                      <p>Use the KudosHub HTTP API action inside Clay. Each email is checked in real time and flagged as
                        disposable, spam trap, catch-all, invalid, or safe. You can filter or remove risky contacts
                        directly from your Clay table based on these returned values.</p>
                    </div>
                  </details>
                </div>

                <div class="wow animate__fadeInUp" data-wow-delay="900ms">
                  <details>
                    <summary>How does KudosHub improve CRM hygiene in Clay workflows?</summary>
                    <div class="faq-content">
                      <p>KudosHub verifies each email before it enters your Clay automations, removes risky contacts,
                        and updates status fields in real time. This prevents data decay, reduces manual cleanup, and
                        ensures your CRM stays accurate and ready for reliable outreach.</p>
                    </div>
                  </details>
                </div>

                <div class="wow animate__fadeInUp" data-wow-delay="1000ms">
                  <details>
                    <summary>How often should I run KudosHub email validation inside Clay tables?
                    </summary>
                    <div class="faq-content">
                      <p>Run validation whenever you add new leads, import data, or update existing records. For
                        long-term hygiene, schedule periodic re-validation to prevent list decay and maintain accurate
                        email quality inside Clay over time.</p>
                    </div>
                  </details>
                </div>

                <div class="wow animate__fadeInUp" data-wow-delay="1100ms">
                  <details>
                    <summary>What is the cost or pricing model for using KudosHub with Clay integration?</summary>
                    <div class="faq-content">
                      <p>KudosHub uses a simple pay-per-validation model. Each email validation consumes 1 credit. If
                        you enable AI scoring, it uses 2 credits, one for validation and one for scoring. There are no
                        additional Clay integration fees.</p>
                    </div>
                  </details>
                </div>

                <div class="wow animate__fadeInUp" data-wow-delay="1200ms">
                  <details>
                    <summary>How do I run bulk email validation inside Clay using KudosHub?</summary>
                    <div class="faq-content">
                      <p>Select your email column, apply the KudosHub HTTP API action, and run the action on your entire
                        table or selected rows. Clay will batch each request and return validation results for all
                        emails directly into your table.</p>
                    </div>
                  </details>
                </div>

                <div class="wow animate__fadeInUp" data-wow-delay="1300ms">
                  <details>
                    <summary>Is there a free tier or trial for testing KudosHub API integrations?</summary>
                    <div class="faq-content">
                      <p>Yes. KudosHub offers 3,000 free credits to test API integrations and evaluate performance. You
                        can
                        start validating emails, checking real-time responses, and automating workflows without any
                        setup
                        costs or long-term commitments.</p>
                    </div>
                  </details>
                </div>

                <div class="wow animate__fadeInUp" data-wow-delay="1400ms">
                  <details>
                    <summary>What data fields does KudosHub return inside Clay after email validation?
                    </summary>
                    <div class="faq-content">
                      <p class="wow animate__fadeInUp">KudosHub returns key data fields including email status, risk
                        level, deliverability outcome, confidence score, AI quality score, reason codes, and metadata
                        indicators such as disposable, catch-all, or spam trap detection.</p>
                    </div>
                  </details>
                </div>
                <p class="wow animate__fadeInUp" data-wow-delay="1100ms"
                  style="font-size: 12px; padding-bottom:0px;margin-top: 30px !important">
                  * 3,000 free validations are distributed as 100 credits per day for 30 days. Unused daily
                  credits expire at the end of each day and do not roll over.
                </p>
                <p class="wow animate__fadeInUp docs-link" data-wow-delay="1300ms"
                  style="font-size: 12px; padding-top:0px;">
                  please refer our
                  <a href="./docs/email-validation" target="-blank">docs</a>
                  for more details
              </div>
            </div>
          </div>
          <!-- faq end -->
        </div>
      </div>
      <app-get-started-today></app-get-started-today>
      <!-- FOOTER START -->
      <div id="appFooter">
        <app-footer></app-footer>
      </div>
      <!-- FOOTER END -->
    </section>
    <section class="body-right-insidepages animate__animated animate__fadeInRight"> <a routerLink="/">
        <div class="pic-area">
          <div class="pic-zoom box02"></div>
          <div class="page-head">
            <div class="cross"><img src="theme/images/cross.svg" width="25" alt="cross"></div>
            <h2>INTEGRATION <img src="theme/images/side-img-icon.webp" width="40" alt="Who we are KudosHub"
                class="icon-pad"></h2>
          </div>
        </div>
      </a>
    </section>
  </div>
  }
</main>
}